import { render, staticRenderFns } from "./ClientWorkListing.vue?vue&type=template&id=3a453e46&"
import script from "./ClientWorkListing.vue?vue&type=script&lang=js&"
export * from "./ClientWorkListing.vue?vue&type=script&lang=js&"
import style0 from "./ClientWorkListing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientWorkListing.vue"
export default component.exports